import { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const DEFAULT_ORDER = [
  "CategoryIconBar",
  "TopDestinations",
  "InteractiveMap",
  "FeaturedPlaces",
  "HotelsSection",
  "AdventuresSection",
  "LocalGuidesSection",
  "CultureSection",
  "TravelGuideSection",
  "PhotoGuideSection",
  "CuisineSection",
  "FestivalsSection",
  "LiveSvanetiConditions",
  "LatestDiscoveries",
  "StatsSection",
  "TodaysHighlight",
];

export function useHomeOrder() {
  const [order, setOrder] = useState(DEFAULT_ORDER);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDoc(doc(db, "siteSettings", "homeComponentOrder"))
      .then((snap) => {
        if (snap.exists()) {
          const savedOrder = snap.data().order || DEFAULT_ORDER;
          const savedItems = snap.data().items || [];
          // merge in any default ids not yet present in a previously saved order
          const missing = DEFAULT_ORDER.filter((id) => !savedOrder.includes(id));
          const fullOrder = [...savedOrder, ...missing];
          // filter out hidden components
          const visible = fullOrder.filter((id) => {
            const item = savedItems.find((i) => i.id === id);
            return !item?.hidden;
          });
          setOrder(visible);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return { order, loading };
}